let store = require("../store");
let actions = require("../actions");

let Drop = mc.widgets.Drop;
let IconButton = mc.widgets.IconButton;

let UserDrop = function (props) {
  let user = props.user;
  let prefs = store.getState().prefs;

  let setSessionPref = function (evt) {
    actions.setPref("stayLoggedIn", evt.target.checked);
  };

  if (!user) {
    return null;
  }

  let account = user.accounts.find((acct) => acct.id === user.accountId);

  return (
    <div className="rc-nav-drop">
      <Drop align="right" autoClose={true}>
        <div className="rc-user-drop-handle mc-icon-button" data-tooltip={tx("account")}>
          <img src="./img/rc/nav_user.svg" width="29" height="29"/>
        </div>
        <ul className="mc-drop-content">
          <li className="rc-nav-user">
            <div className="rc-nav-user-name">
              {mc.format.name(user)}
            </div>
            <div className="rc-nav-user-acct">
              {account ? account.displayName : null}
            </div>
            <div className="rc-nav-user-email">
              {user.email}
            </div>
            <div className="rc-nav-user-opts">
              <label>
                <input type="checkbox" checked={prefs.stayLoggedIn} onChange={setSessionPref}/>
                {tx("stay_logged_in")}
              </label>
            </div>
          </li>
          <li>
            <IconButton
              icon="users"
              display="text"
              label={tx("users")}
              scale={1}
              onPress={() => mc.router.trigger("USER_LIST_VIEW")}
              id="rc-nav-users-button"/>
          </li>
          <li>
            <IconButton
              icon="password"
              display="text"
              label={tx("change_password")}
              scale={0.9}
              onPress={props.onRequestPassword}
              id="rc-nav-password-button"/>
          </li>
          <li>
            <IconButton
              icon="close"
              display="text"
              label={tx("log_out")}
              scale={0.9}
              weight="bold"
              onPress={props.onLogout}
              id="rc-nav-signout-button"/>
          </li>
        </ul>
      </Drop>
    </div>
  );
};

module.exports = UserDrop;
